import { ajax } from '../ajax'


//、 授课-课中作业列表
export const reqSKHomeWorkList = (paramets) => ajax(`/homework/jxHomework/list`, paramets)
//、 教学作业-通过id查询作业完成学生人数
export const reqSKHomeWorkStuCount = (paramets) => ajax(`/homeworkstu/jxHomeworkStu/getStuCount`, paramets)
//、 教学作业-通过id查询作业未完成学生人数
export const reqSKHomeWorkStuCountList = (paramets) => ajax(`/homeworkstu/jxHomeworkStu/getStulists`, paramets)
//、 教学作业-通过id查询作业详情
export const reqSKHomeWorkDetails = (paramets) => ajax(`/homework/jxHomework/queryById`, paramets)
//、 教学作业-获取作业测验详情
export const reqSKHomeWorkTestList = (paramets) => ajax(`/test/jxTest/gettestshow`, paramets)
//、教学作业-获取作业完成情况
export const reqSKHomeWorkStuMessage = (paramets) => ajax(`/homework/jxHomework/getStuByHomeworkId`, paramets)
//、教学作业-获取作业编辑
export const reqSKHomeWorkEdit = (paramets) => ajax(`/homework/jxHomework/edit`, paramets, 'put')
